/* La Tech — motor "en vivo". Lee el horario desde #latech-horario (sección Estado La Tech)
   y actualiza todo lo que tenga data-lt. Sin dependencias. Hora de Santiago.
   Días especiales: "AAAA-MM-DD cerrado" o "AAAA-MM-DD 8:00-14:00", uno por línea. */
(function () {
  if (window.LaTechVivo) return;

  var DIAS = ['', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado', 'domingo'];

  function rango(s) {
    var m = String(s || '').match(/(\d{1,2})(?::(\d{2}))?\s*[-–a]\s*(\d{1,2})(?::(\d{2}))?/);
    return m ? [(+m[1]) * 60 + (+(m[2] || 0)), (+m[3]) * 60 + (+(m[4] || 0))] : null;
  }
  function hora(s, def) {
    var m = String(s || '').match(/(\d{1,2})(?::(\d{2}))?/);
    return m ? (+m[1]) * 60 + (+(m[2] || 0)) : def;
  }
  function fmt(min) { var m = min % 60; return Math.floor(min / 60) + ':' + (m < 10 ? '0' : '') + m; }
  function dos(n) { return (n < 10 ? '0' : '') + n; }

  function config() {
    var el = document.getElementById('latech-horario'), c = {};
    try { if (el) c = JSON.parse(el.textContent); } catch (e) {}
    var lj = c.lunJue != null ? c.lunJue : '8:00-19:00';
    var h = { 1: rango(lj), 2: rango(lj), 3: rango(lj), 4: rango(lj),
      5: rango(c.vie != null ? c.vie : '8:00-18:00'),
      6: rango(c.sab != null ? c.sab : '10:00-14:00'),
      7: rango(c.dom || '') };
    var dias = String(c.diasCorte || '1,2,3,4,5,6').split(',').map(Number).filter(function (x) { return x >= 1 && x <= 7; });
    var esp = {};
    String(c.especiales || '').split(/\n|;/).forEach(function (linea) {
      var m = linea.match(/(\d{4}-\d{2}-\d{2})\s*(.*)$/);
      if (!m) return;
      esp[m[1]] = /cerrad/i.test(m[2]) ? 'cerrado' : (rango(m[2]) || 'cerrado');
    });
    return { h: h, corte: hora(c.corte, 780), dias: dias, esp: esp, avisoHasta: c.avisoHasta || '' };
  }

  var fmtTz = new Intl.DateTimeFormat('en-US', { timeZone: 'America/Santiago', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false });
  function ahora() {
    var o = {};
    fmtTz.formatToParts(new Date()).forEach(function (p) { o[p.type] = p.value; });
    return { y: +o.year, mo: +o.month, da: +o.day, min: (+o.hour % 24) * 60 + (+o.minute), s: +o.second };
  }
  function fecha(t, n) {
    var d = new Date(Date.UTC(t.y, t.mo - 1, t.da + n));
    var wd = d.getUTCDay();
    return { n: n, iso: d.toISOString().slice(0, 10), wd: wd === 0 ? 7 : wd, dia: d.getUTCDate() };
  }
  function horario(cfg, f) {
    if (cfg.esp[f.iso] === 'cerrado') return null;
    return cfg.esp[f.iso] || cfg.h[f.wd] || null;
  }
  function corteDe(cfg, f) {
    var hor = horario(cfg, f);
    if (!hor || cfg.dias.indexOf(f.wd) < 0) return null;
    return Math.min(cfg.corte, hor[1]);
  }
  function proximo(cfg, t, ok) {
    for (var n = 1; n <= 21; n++) { var f = fecha(t, n); if (ok(f)) return f; }
    return fecha(t, 1);
  }
  function cuando(f) { return f.n === 1 ? 'mañana' : 'el ' + DIAS[f.wd] + ' ' + f.dia; }

  function cada(sel, fn) { var l = document.querySelectorAll(sel); for (var i = 0; i < l.length; i++) fn(l[i]); }
  function poner(el, v) { if (el.textContent !== v) el.textContent = v; }
  function plantilla(el, key, vars) {
    var t = el.getAttribute(key); if (!t) return;
    poner(el, t.replace(/\{(\w+)\}/g, function (_, k) { return vars[k] != null ? vars[k] : ''; }));
  }

  function pintar() {
    var cfg = config(), t = ahora(), hoy = fecha(t, 0), hor = horario(cfg, hoy);
    var abierto = !!hor && t.min >= hor[0] && t.min < hor[1];
    var antesDeAbrir = !!hor && t.min < hor[0];
    var corte = corteDe(cfg, hoy);
    var corteHoy = corte != null && t.min < corte;
    var fCorte = proximo(cfg, t, function (f) { return corteDe(cfg, f) != null; });
    var fAbre = proximo(cfg, t, function (f) { return !!horario(cfg, f); });
    var diaSale = cuando(fCorte);
    var corteSig = corteDe(cfg, fCorte);
    var falta = corteHoy ? Math.max(0, (corte - t.min) * 60 - t.s) : 0;
    var fh = Math.floor(falta / 3600), fm = Math.floor(falta % 3600 / 60), fs = falta % 60;
    var corteTxt = fmt(corteHoy ? corte : corteSig);
    var vars = { corte: corteTxt, dia: diaSale, cierre: hor ? fmt(hor[1]) : '' };
    var abreTxt = cuando(fAbre) + ' a las ' + fmt(horario(cfg, fAbre) ? horario(cfg, fAbre)[0] : 0);

    var local = abierto ? 'Local abierto, cierra ' + fmt(hor[1])
      : antesDeAbrir ? 'Abre hoy a las ' + fmt(hor[0])
      : 'Local cerrado, abre ' + abreTxt;

    cada('[data-lt="aviso"]', function (el) { el.hidden = !!cfg.avisoHasta && hoy.iso > cfg.avisoHasta; });
    cada('[data-lt="pulso"]', function (el) { el.classList.toggle('is-off', !abierto); });
    cada('[data-lt="local"]', function (el) { poner(el, local); });
    cada('[data-lt="corte"]', function (el) { poner(el, corteHoy ? 'pide antes de las ' + fmt(corte) : 'sale ' + diaSale); });
    cada('[data-lt="titulo"]', function (el) { plantilla(el, corteHoy ? 'data-antes' : 'data-despues', vars); });
    cada('[data-lt="reloj-label"]', function (el) { poner(el, corteHoy ? 'El corte cierra en' : 'Próximo corte'); });
    cada('[data-lt="reloj"]', function (el) {
      poner(el, corteHoy ? dos(fh) + ':' + dos(fm) + ':' + dos(fs) : (fCorte.n === 1 ? 'mañana' : DIAS[fCorte.wd] + ' ' + fCorte.dia) + ' ' + fmt(corteSig));
    });
    cada('[data-lt="cta"]', function (el) { plantilla(el, corteHoy ? 'data-antes' : 'data-despues', vars); });
    /* Etiqueta en las tarjetas de producto de Focal, sin editar archivos del tema */
    if (document.getElementById('latech-horario')) {
      cada('product-item:not(.product-item--sold-out)', function (item) {
        if (item.querySelector('[data-lt="llega"]')) return;
        var wrap = item.querySelector('.product-item__image-wrapper'); if (!wrap) return;
        var lista = wrap.querySelector('.product-item__label-list');
        if (!lista) { lista = document.createElement('div'); lista.className = 'product-item__label-list label-list'; wrap.insertBefore(lista, wrap.firstChild); }
        var tag = document.createElement('span');
        tag.className = 'label'; tag.setAttribute('data-lt', 'llega'); tag.title = 'Despacho same day en Santiago';
        lista.appendChild(tag);
      });
    }
    cada('[data-lt="llega"]', function (el) {
      poner(el, corteHoy ? 'Llega hoy' : 'Llega ' + diaSale);
      el.classList.toggle('lt-llega--hoy', corteHoy);
      el.classList.toggle('lt-llega--despues', !corteHoy);
    });
    cada('[data-lt="vivo-corte"]', function (el) { poner(el, corteHoy ? 'Quedan ' + fh + ' h ' + fm + ' min para pedir' : 'Corte cerrado, sale ' + diaSale); });
    cada('[data-lt="vivo-retiro"]', function (el) {
      poner(el, abierto ? 'Abierto ahora, cierra ' + fmt(hor[1]) : antesDeAbrir ? 'Desde las ' + fmt(hor[0]) : 'Retiras ' + abreTxt.replace(' a las ', ' desde las '));
    });
    cada('[data-lt="vivo-bici"]', function (el) { poner(el, corteHoy ? 'Pide antes de las ' + fmt(corte) + ' y sale hoy' : 'Próxima salida ' + diaSale); });
    cada('[data-lt="vivo-guarda"]', function (el) {
      poner(el, abierto ? 'Recibimos hoy hasta las ' + fmt(hor[1]) : antesDeAbrir ? 'Hoy recibimos desde las ' + fmt(hor[0]) : 'Recibimos ' + abreTxt.replace(' a las ', ' desde las '));
    });
  }

  window.LaTechVivo = { pintar: pintar };
  pintar();
  setInterval(pintar, 1000);
  document.addEventListener('shopify:section:load', pintar);
})();
